// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Yr4K","productName":"Table_productName__1yId-"};